import React from 'react';
import { FaAward, FaStar, FaHeart, FaDownload } from "react-icons/fa";

export default {
  awards: [
    {
      icon: <FaAward />,
      count: 100,
      body: "Awards",
    },
    {
      icon: <FaDownload />,
      count: 12000,
      body: "Downloads",
    },
    {
      icon: <FaStar />,
      count: 10000,
      body: "Ratings",
    },
    {
      icon: <FaHeart />,
      count: 15000,
      body: "Loves",
    },
  ],
};
